module.exports = __webpack_public_path__ + "media/images/cover/2-4f4390afac95ae82261591786db6b994.jpg";